import { isFilledArray } from "./getFilledArrayOrDefault";

/**
 * Validates that all mandatory required images have been uploaded
 * @param required_images - Array of FILTERED required image configurations (already filtered by meta_conditions)
 * @param images - Array of uploaded images
 * @param show_toast - Whether to show error toast
 * @returns boolean - true if valid, false if invalid
 */
export function validateRequiredImages(
    required_images: any[] = [],
    images: any[] = [],
    show_toast = true
) {
    // Note: required_images should already be filtered by meta_conditions before calling this function
    // using config.get_check_required_images() or config.get_fruit_required_images()

    // Find any mandatory image that doesn't have at least one uploaded image
    const missingImage = required_images.find((req_image) => {
        if (req_image.mandatory) {
            const hasImage = isFilledArray(images.filter((img) => img.type === req_image.type));
            return !hasImage;
        }
        return false;
    });

    if (missingImage) {
        if (show_toast) {
            // Only import toast when needed
            import("react-toastify").then(({ toast }) => {
                toast.error(`Please upload at least one ${missingImage.label} image`);
            });
        }
        return false;
    }

    return true;
}

